import type { ForwardScatterResult } from '../scan/forward-scatter.js';

const PANEL_ID = 'forwardScatterPanel';
const MAX_ROWS = 5;

function el(): HTMLElement | null {
  return document.getElementById(PANEL_ID);
}

export function clearForwardScatterPanel(): void {
  const root = el();
  if (!root) return;
  root.innerHTML = '<div class="forward-scatter-empty small">No forward-scatter data yet.</div>';
}

export function drawForwardScatterPanel(result: ForwardScatterResult | null | undefined): void {
  const root = el();
  if (!root) return;
  if (!result) {
    clearForwardScatterPanel();
    return;
  }
  if (!result.hasBaseline) {
    root.innerHTML = '<div class="forward-scatter-no-baseline">No calibration baseline yet &mdash; run Calibrate to enable obstruction detection.</div>';
    return;
  }
  const obstructions = result.obstructions.slice(0, MAX_ROWS);
  const summary = `<div class="forward-scatter-summary">total score: ${result.totalScore.toExponential(2)} &middot; events: ${result.obstructions.length}</div>`;
  if (obstructions.length === 0) {
    root.innerHTML = summary + '<div class="forward-scatter-empty small">No significant obstructions detected.</div>';
    return;
  }
  const rows = obstructions.map((o) => {
    const pct = (o.dropRatio * 100).toFixed(0);
    return `<li class="forward-scatter-row">`
      + `<span class="fs-range">${o.range.toFixed(2)} m</span>`
      + `<span class="fs-drop">-${pct}%</span>`
      + `</li>`;
  }).join('');
  root.innerHTML = summary + `<ul class="forward-scatter-list">${rows}</ul>`;
}
